// extracted by mini-css-extract-plugin
export default {"logos":"sliderBack_logos__2YfKL","slide":"sliderBack_slide__q2Y++"};